{
    "InboundcallsHeader": "Eingehende Anrufe",
    "InboundcallsAvgordervalueLabel": "Durchschnittlicher Bestellwert:",
    "InboundcallsStrikerateLabel": "Trefferquote (Anrufe pro Auftrag):",
    "OutboundcallsHeader": "Ausgehende Anrufe",
    "OutboundcallsAvgordervalueLabel": "Durchschnittlicher Bestellwert:",
    "OutboundcallsStrikerateLabel": "Trefferquote (Anrufe pro Auftrag):",
    "MonetaryCallAssignments_SectionHeader": "Monetäre Anrufzuweisungen",
    "MonetaryCallAssignments_SectionPara": "Sie können steuern, wie finanzielle\/monetäre Anrufstatistiken berechnet werden, indem Sie erfolgreichen eingehenden und ausgehenden Anrufen geschätzte Verkaufsauftrags- oder Geldwerte zuweisen und eine Anruftrefferrate als Anzahl der Anrufe pro Verkauf\/Bestellung angeben.",
    "NAME": "MonetaryCallAssignments"
}